import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { SplashScreenService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/SplashScreenService";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { GridFilter, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { InvVoucherPricing } from "../../models/inv-voucher-pricing.model";
import { InvVoucherPricingFormComponent } from "../inv-voucher-pricing-form/inv-voucher-pricing-form.component";

@Component({
  selector: "ngx-inv-voucher-pricing-list",
  templateUrl: "./inv-voucher-pricing-list.component.html",
  styleUrls: ["./inv-voucher-pricing-list.component.scss"],
})
export class InvVoucherPricingListComponent extends BaseListComponent {
  filterInfo: NameValue[] = [];
  actions: EntityListAction[];
  constructor(private _tabsservice: TabularService, private splashScreenService: SplashScreenService, private splashFormService: SplashFormService) {
    super();
    this.inputEditorform = InvVoucherPricingFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    this.apiName = "InvVoucherPricing";
    this.areaName = "Inventory";
    this.label = "قیمت گذاری اسناد";
    this.setactions();
    if (this.accountService.authService.currentFiscalYear)
      this.filterInfo.push({ Name: "FiscalYearId", Value: this.accountService.authService.currentFiscalYear.Id, Operator: "eq" });
    else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.filterInfo.push({ Name: "FiscalYearId", Value: x.Id, Operator: "eq" });
        }
      });
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: InvVoucherPricing,
    onRowsSelected: InvVoucherPricing[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    if (onRowSelected && (!onRowsSelected || onRowsSelected.length <= 0)) onRowsSelected = [onRowSelected];
    ///قیمت گذاری
    if (action.name === "VoucherPricing") {
      this.dialogService
        .open(this.inputEditorform, {
          context: {
            currentrow: onRowSelected,
            apiName: action.apiName,
            areaName: action.areaName,
            label: this.label,
          },
          hasScroll: true,
          autoFocus: true,
          closeOnBackdropClick: false,
          closeOnEsc: false,
        })
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {
          this._tabsservice.tabItemonRefreshData.next(this.apiName);
        });
    }
    ///برگشت از قیمت گذاری
    if (action.name === "ReturnVoucherPricing") {
      this.splashFormService.openDialog("", "در حال برگشت از قیمت گذاری");
      if (isAllSelected) {
        this.httpCommonService
          .create("InvVoucherPricing/ReturnVoucherPricing", gridFilter)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (data) => {
              this.splashFormService.closeLoading();
              this._tabsservice.tabItemonRefreshData.next(this.apiName);
              this.sts.showDialog("برگشت قیمت گذاری  با موفقیت انجام شد.", "");
            },
            (error) => {
              this.splashFormService.closeLoading();
              this.sts.showDialog(`خطا در ${Utilities.getHttpResponseMessage(error)}`, "خطا");
            }
          );
      } else {
        let InvVoucherPricingIds: number[] = [];
        onRowsSelected.forEach((x) => InvVoucherPricingIds.push(x.Id));
        gridFilter.push({ Type: "F", Filed: "InvVoucherPricingIds", Value: InvVoucherPricingIds, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
        this.httpCommonService
          .create("InvVoucherPricing/ReturnVoucherPricing", gridFilter)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (data) => {
              this.splashFormService.closeLoading();
              this._tabsservice.tabItemonRefreshData.next(this.apiName);
              this.sts.showDialog("برگشت قیمت گذاری  با موفقیت انجام شد.", "");
            },
            (error) => {
              this.splashFormService.closeLoading();
              this.sts.showDialog(`خطا در ${Utilities.getHttpResponseMessage(error)}`, "خطا");
            }
          );
      }
    }
    return;
  }
  setactions() {
    this.actions = [
      {
        name: "VoucherPricing",
        disabled: false,
        displayName: "قیمت گذاری",
        iconName: "icon-create_new_folder-o",
        apiName: "InvVoucherPricing/VoucherPricing",
        areaName: "Inventory",
        requireSelectedrows: false,
        Form_Component: InvVoucherPricingFormComponent,
        permission: Permission.samePermission,
      },
      {
        name: "ReturnVoucherPricing",
        disabled: false,
        displayName: "برگشت از قیمت گذاری",
        iconName: "icon-delete-sweep-outline",
        apiName: "InvVoucherPricing/ReturnVoucherPricing",
        areaName: "Inventory",
        requireSelectedrows: true,
        permission: Permission.samePermission,
      },
    ];
  }
}
